<template>
  <div>
    <b-container class="mt-5 mb-5">
      <Introduction />
      <div class="mb-4">
        <template v-if="isAdmin() || isManager()">
          <b-button
            to="/manage/events/create"
            variant="primary"
            class="mb-2 float-right"
          >
            Nieuw evenement
          </b-button>
        </template>
        <h1 class="fs-4 font-weight-bold mb-4">Evenementen</h1>
      </div>
      <template v-if="events.length">
        <template v-for="(event, key) in events">
          <EventItem :key="key" :event="event" />
        </template>

        <b-pagination
          v-if="totalRows > perPage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          class="mt-4"
          @change="onPageChange"
        />
      </template>
      <b-card
        v-if="!events.length"
        bg-variant="dotted"
        no-body
        class="mb-3 cursor-pointer"
        @click="newEvent"
      >
        <b-card-body class="text-center">
          <font-awesome-icon
            icon="fa-solid fa-calendar"
            size="3x"
            class="mb-2 text-muted"
          />
          <div>Geen aankomende evenementen.</div>
          <div class="text-muted">
            Ga aan de slag door een nieuw evenement aan te maken.
          </div>
        </b-card-body>
      </b-card>
      <div class="text-center">
        <router-link to="/manage/events/archive" class="text-primary">
          Afgelopen evenementen
          <font-awesome-icon icon="chevron-right" />
        </router-link>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useShopStore } from "@/stores/shop";

import Introduction from "@/components/Introduction";
import EventItem from "@/components/event/EventItem";

export default {
  metaInfo: {
    title: "Evenementen",
  },
  components: {
    Introduction,
    EventItem,
  },
  data() {
    return {
      events: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    };
  },
  computed: {},
  methods: {
    ...mapActions(useShopStore, ["setLoading", "isAdmin"]),
    newEvent: function () {
      this.$router.push("/manage/events/create");
    },
    getEvents(page = 1) {
      this.setLoading(true);

      this.$axios
        .get(
          `https://api.tixgo.nl/events?page=${page}&per_page=${this.perPage}`,
        )
        .then((response) => {
          this.events = response.data.data;
          this.totalRows = response.data.total;
          this.currentPage = response.data.current_page;

          this.setLoading(false);
        })
        .catch((reason) => {
          console.log(reason);
          this.setLoading(false);
        });
    },
    isAdmin() {
      return localStorage.getItem("role") == "administrator" ? true : false;
    },
    isManager() {
      return localStorage.getItem("role") == "manager" ? true : false;
    },
    onPageChange(page) {
      this.getEvents(page);
    },
  },
  created() {
    this.getEvents(1);
  },
};
</script>
